// Etiquetas de peso de las líneas por peso (súper). Funciones puras, sin React ni red:
// las comparten la tienda online (carrito), el SMS de confirmación y el KDS, para que
// «1,5 lb» se escriba UNA sola vez.

export type WeightLabelLocale = "es" | "en"

/**
 * Peso de una línea para mostrar, según el idioma (R5): coma en español
 * (1500 → «1,5 lb»), punto en inglés («1.5 lb»). Sin idioma, español. Sin unidad,
 * solo el número.
 */
export function retailWeightLabel(
  weightMilli: number,
  unit: string | null | undefined,
  locale: WeightLabelLocale = "es",
): string {
  const raw = String(Math.round(weightMilli) / 1000)
  const w = locale === "en" ? raw : raw.replace(".", ",")
  return unit ? `${w} ${unit}` : w
}

/**
 * Nombre de una línea de la comanda/KDS. Sin peso (todo restaurante) devuelve `name`
 * tal cual. Con peso lo agrega: con la unidad si se conoce («Banana · 1,5 lb»; la
 * unidad vive en `items.weight_unit`, no en `order_items`). Si no se conoce, el
 * número y la marca «(peso)» / «(weight)» para que cocina no lo lea como cantidad.
 * `weight` viene de `order_items.weight` (unidad de venta, p. ej. 1.5), no en milésimas.
 */
export function kitchenLineName(
  name: string,
  weight: number | null | undefined,
  locale: WeightLabelLocale = "es",
  unit?: string | null,
): string {
  if (weight == null || !(Number(weight) > 0)) return name
  const label = retailWeightLabel(Number(weight) * 1000, unit, locale)
  if (unit) return `${name} · ${label}`
  return `${name} · ${label} (${locale === "en" ? "weight" : "peso"})`
}
